import { render, staticRenderFns } from "./GiftyIcon.vue?vue&type=template&id=2592b23a&scoped=true&"
import script from "./GiftyIcon.vue?vue&type=script&lang=js&"
export * from "./GiftyIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2592b23a",
  null
  
)

export default component.exports